import React from 'react';
import ReactDOM from 'react-dom/client';

import BufferTabView from 'buffers/BufferTabView';
import {renderToDOM, unmountRootsAsync} from 'redux-stores/ReduxDOMRender';

import StudyItemsListing from '../studyItems/StudyItemsListing';
import StudyListingTabState from './StudyListingTabState';

export default class StudyListingTabView extends BufferTabView<StudyListingTabState> {
  reactRoot: ReactDOM.Root | null = null;

  static override initClass(): void {
    this.prototype.className = 'buffer-tab buffer-tab--no-padding';
  }

  override render(): this {
    const id = this.model.get('studyId');
    const type = this.model.get('studyType');
    this.reactRoot = renderToDOM(
      <StudyItemsListing studyId={id} studyType={type} />,
      this.el,
      this.reactRoot
    );
    return this;
  }

  override removeAsync(callback: () => void): this {
    unmountRootsAsync([this.reactRoot], () => {
      this.reactRoot = null;
      super.remove();
      callback();
    });
    return this;
  }
}

StudyListingTabView.initClass();
